import { render, staticRenderFns } from "./advance-withdrawal-accumulation.vue?vue&type=template&id=bafb2336"
import script from "./advance-withdrawal-accumulation.vue?vue&type=script&lang=js"
export * from "./advance-withdrawal-accumulation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports